export function formatDate(
  date?: string | Date | null,
  format = "LL",
  { timezone }: { timezone?: string } = {},
) {
  if (!date) return "";
  const options: Intl.DateTimeFormatOptions =
    format === "lll"
      ? {
          day: "numeric",
          month: "short",
          year: "numeric",
          hour: "numeric",
          minute: "numeric",
          timeZone: timezone,
        }
      : {
          day: "numeric",
          month: "long",
          year: "numeric",
          timeZone: timezone,
        };
  return new Intl.DateTimeFormat("ru", options).format(
    date instanceof Date ? date : new Date(date),
  );
}
